import { useEffect, useRef } from 'react';
import { Platform } from 'react-native';
import RBSheet from 'react-native-raw-bottom-sheet';

import { useBottomSheet } from '@/contexts/bottomSheetContext';

interface BottomSheetRef {
  open: () => void;
  close: () => void;
}

const SharedBottomSheet = () => {
  const filtersRef = useRef<BottomSheetRef>(null);

  const {
    state: { height, content, visible },
    dispatch
  } = useBottomSheet();

  const closeSheet = () => {
    dispatch({ type: 'SET_VISIBLE', setVisible: false });
  };

  useEffect(() => {
    return visible ? filtersRef.current?.open() : filtersRef.current?.close();
  }, [visible]);

  return (
    <RBSheet
      ref={filtersRef}
      draggable
      onClose={closeSheet}
      height={height}
      customModalProps={{
        animationType: 'fade',
        statusBarTranslucent: true
      }}
      customStyles={{
        container: [
          {
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10
          },
          Platform.OS === 'web' && { maxWidth: 992, marginHorizontal: 'auto' }
        ],
        draggableIcon: {
          backgroundColor: 'transparent'
        }
      }}>
      {content}
    </RBSheet>
  );
};

export default SharedBottomSheet;
